import { createAxios, logNative } from '../../utils/utils';
import {
  COMMENT_INFO_80,
  COMMENT_LIST_80,
  COMMENT_ZAN_80,
  COMMENT_ADD_80,
  COMMENT_REPORT_80,
} from '../../config';
import React from 'react';
import Toast from '../../components/Toast/Toast';
import { COMMENT_REPLY_80 } from './../../config/index';
import { Button, message } from 'antd';

export default {
  async getCommentInfo(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_INFO_80, {
        ...params,
      });
      if (res.data.status === 0) {
        return res.data.data;
      } else {
        return null;
      }
    } catch (err) {
      logNative(`获取评论相关信息报错${err}`);
      return null;
    }
  },
  async getCommentList(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_LIST_80, {
        ...params,
      });
      if (res?.data?.status === 0) {
        return res.data.data;
      }
    } catch (err) {
      logNative(`获取评论列表出错${err}`);
    }
  },

  async setCommentZan(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_ZAN_80, {
        ...params,
      });
      if (res?.data?.status === 0) {
        Toast.success({
          content: '点赞成功',
        });
      } else {
        Toast.error({
          content: res?.data?.message || '点赞失败',
        });
      }
      return res?.data;
    } catch (err) {
      logNative(`评论点赞出错 params:${JSON.stringify(params)} err: ${err}`);
    }
  },

  async addCommentCon(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_ADD_80, {
        ...params,
      });
      return res.data;
    } catch (err) {
      logNative(`提交评论出错 params:${JSON.stringify(params)} err: ${err}`);
    }
  },

  async addCommentReply(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_REPLY_80, {
        ...params,
      });
      return res.data;
    } catch (err) {
      logNative(`提交回复出错 params:${JSON.stringify(params)} err: ${err}`);
    }
  },

  async reportComment(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.post(COMMENT_REPORT_80, {
        ...params,
      });
      if (res.data.status === 0) {
        Toast.success({
          content: '举报成功',
        });
      } else {
        Toast.error({
          content: '举报出错',
        });
      }
      return res.data;
    } catch (err) {
      logNative(`举报出错 params:${JSON.stringify(params)} err: ${err}`);
    }
  },
};

export const sorts = [
  {
    name: 'HOT',
    text: '热门',
  },
  {
    name: 'DATE',
    text: '最新',
  },
];

export const grades = [
  {
    name: '-1',
    text: '评分',
  },
  {
    name: '5',
    text: '好评',
  },
  // {
  //   name: '4',
  //   text: '4星',
  // },
  {
    name: '3',
    text: '中评',
  },
  // {
  //   name: '2',
  //   text: '2星',
  // },
  {
    name: '1',
    text: '差评',
  },
];

// comt editor
export const STAR_NUM = ['', 'one', 'two', 'three', 'four', 'five'];
export const COMT_IMG_LIMIT = 5;
export const COMT_SOFT_LIMIT = 5;
export const COMT_SPECIAL_LIMIT = 3;
export const COMT_MAX_TEXT_COUNT = 400;
export const COMT_SCORE_LABELS = ['', '差评', '差评', '中评', '好评', '好评'];
